/**
 * Created by Hideo Yamada
 * 01/22/2019
 * https://marvelapp.com/53405j1/screen/50159397/layer/75234564
 */

import React from 'react';
import PropTypes from 'prop-types';
import MonthCalendar from 'rc-calendar/lib/MonthCalendar';
import DatePicker from 'rc-calendar/lib/Picker';
import moment from 'moment';

const calendar = (disabledDate) => <MonthCalendar disabledDate={disabledDate} style={{ marginTop: '30px', zIndex: 1000 }} />;
const ALIGN = {
    left: { points: ['tl', 'tr'] },
    right: { points: ['tr', 'tr'] },
};

const MonthPicker = ({ 
    align = 'left', 
    disabledDate = () => null, 
    value = moment(), 
    trigger = null, 
    onChange = () => {} 
}) => (
    <DatePicker calendar={calendar(disabledDate)} align={ALIGN[align]} defaultValue={value.start} onChange={onChange} dropdownClassName="custom-month-picker">
        {() => trigger}
    </DatePicker>
);

MonthPicker.propTypes = {
    trigger: PropTypes.node,
    value: PropTypes.object,
    onChange: PropTypes.func,
};

export default MonthPicker;
